import { axiosBase, axiosDevelopment } from './config';

export const TemplateService = {
    GET_TEMPLATE_THUMBNAILS(userID, sessionID, template) {
        return axiosDevelopment.get(`ajax/get-blocks-new-api?u=${userID}&sn=${sessionID}&t=${template}`);
    },
    GET_TEMPLATE_DATA(templateID, userID, sessionID) {
        return axiosDevelopment.get(`ajax/get-blocks/${templateID}?u=${userID}&sn=${sessionID}`);
    },
    POST_TEMPLATE(data) {
        return axiosDevelopment.post(`ajax/block-snapshot`, data);
    },
    POST_TEMPLATE_NAME_UPDATE(data) {
        return axiosBase.post(`f2020_update_blocks`, data);
    },
    POST_TEMPLATE_DELETE(data) {
        return axiosBase.post(`f2020_delete_block`, data);
    },
};